import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from "../servicios/auth.service";
import { map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authSvc:AuthService, private route:Router)
  {

  }
  canActivate(): Observable<boolean> {
    return this.authSvc.userData.pipe(
      map(user=>
        {
          if(!user)
          {
            //redirigir al login
            this.route.navigate(['/login'])
            return false;
          }
          return true;
        })
    )
  }
  
}
